import { CUSTOMER_ORDER, CUSTOMERS } from "./customers";

export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

export const newQuestion = () => ({
  id: uid(), text: "", options: [0, 1, 2, 3].map(() => ({ text: "", correct: false })), time_limit: 20, points: "standard",
});

export const newCustomer = (i, nq = 1) => {
  const type = CUSTOMER_ORDER[i % CUSTOMER_ORDER.length];
  return { id: uid(), type, name: CUSTOMERS[type].name, background: "default", questions: Array.from({ length: nq }, () => newQuestion()) };
};

export const skeleton = ({ title, language, customers, questions }) => ({
  title, description: "", language, shirt_color: "#2c397e",
  settings: { read_time: 10, show_scoreboard: true, auto_advance: false, options_on_phone: true, music: true },
  customers: Array.from({ length: customers }, (_, i) => newCustomer(i, questions)),
});

export function questionIssues(q) {
  const issues = [];
  if (!q.text.trim()) issues.push("issue_text");
  const filled = q.options.filter((o) => o.text.trim());
  if (filled.length < 2) issues.push("issue_options");
  if (!filled.some((o) => o.correct)) issues.push("issue_correct");
  return issues;
}

export function move(arr, i, dir) {
  const j = i + dir;
  if (j < 0 || j >= arr.length) return;
  [arr[i], arr[j]] = [arr[j], arr[i]];
}
